<template>
  <Item tag="router-link" :to="action" :type="value.typename.toLowerCase()" :title="message | Limit">
    <template #datetime>
      <FontAwesomeIcon :icon="['fal', 'calendar']" style="margin-right: 3px" />
      {{ value.createdAt | Moment('DD. MMM [kl.] HH.mm') }}
    </template>
    <template #details>
      <Avatar
        v-if="value.author"
        :value="{ src: value.author.avatar, name: value.author.name }"
        size="nano"
        class="list-item__detail--no-fade"
      />
      <div v-if="$route.name === 'dashboard' && value.reference.project">
        <FontAwesomeIcon :icon="['fal', 'drafting-compass']" style="margin-right: 3px" />
        {{ value.reference.project.name }}
      </div>
    </template>
  </Item>
</template>

<script>
import { StripSimpleMarkdown } from '@/utils'
import { LeadPathByModel } from '@/components/Lead/utils'
import { Moment, Limit } from '@/filters'

import Avatar from '@/components/Avatar'
import Item from '@/components/ListItem'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    message() {
      return StripSimpleMarkdown(this.value.message)
    },
    action() {
      switch (this.value.reference.onModel) {
        case 'Lead':
          const context = LeadPathByModel[this.$path('reference.reference.onModel', this.value) || 'Project']

          return {
            name: `${context}-lead`,
            params: { id: this.value.reference.id, reference: this.value.reference.reference.id },
          }
        case 'Contact':
          return {
            name: 'contact-dashboard',
            params: { id: this.value.reference.id },
          }
      }
    },
  },
  filters: {
    Moment,
    Limit,
  },
  components: {
    Item,
    Avatar,
  },
}
</script>

<style lang="scss">
.list-item--comment {
  a {
    text-decoration: none;
  }
}
</style>
